export const DASHBOARD_SET_USERNAME = 'DASHBOARD_SET_USERNAME'
export const DASHBOARD_SET_ACTIVE_USERS = 'DASHBOARD_SET_ACTIVE_USERS'
export const DASHBOARD_SET_CALLEE = 'DASHBOARD_SET_CALLEE'
